import React from 'react';

import { Box, Link, Typography } from '@mui/material';

import type { AssetField } from './AssetFieldGrid';

export default function AssetFieldCell({ label, value, href }: AssetField) {
  const hasValue = value || value === 0;

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ py: 0.75, borderBottom: 1, borderColor: 'divider' }}>
        {label}
      </Typography>
      <Box sx={{ py: 0.75, borderBottom: 1, borderColor: 'divider' }}>
        {hasValue && href ? (
          <Link href={href} target="_blank" rel="noopener noreferrer" variant="body2">
            {value}
          </Link>
        ) : (
          <Typography variant="body2">{hasValue ? value : '—'}</Typography>
        )}
      </Box>
    </>
  );
}
